import { isNullish } from "../../../util/general";

export function replaceCssVarInvocations(varObj, css) {
  const varNames = Object.keys(varObj);
  let out = css;
  for (const varName of varNames) {
    const varValue = varObj[varName];
    const regex = new RegExp(`var\\(\\s*${varName}\\s*\\)`, "gi");
    out = !isNullish(varValue) ? out.replace(regex, varValue) : out;
  }
  return out;
}
